module.exports = __webpack_public_path__ + "static/img/tab-guide.75cab19.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/class/tab-guide.png
// module id = WGe8
// module chunks = 1